import { render } from "./HeadingSection.vue?vue&type=template&id=c963b4b6"
import script from "./HeadingSection.vue?vue&type=script&lang=js"
export * from "./HeadingSection.vue?vue&type=script&lang=js"

import "./HeadingSection.vue?vue&type=style&index=0&id=c963b4b6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__